export function QBOSupportClearAllNonExistingContactsCtrl ($scope, $uibModalInstance, workshopAPI, result) {

  $scope.result = result ? result : {};
}